var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurchaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.1875 0.558594H2.83024C3.84986 0.558594 4.65234 1.43661 4.56737 2.44679L3.78377 11.85C3.6516 13.3889 4.86948 14.7106 6.4178 14.7106H16.4725C17.832 14.7106 19.0215 13.5966 19.1254 12.2465L19.6352 5.1658C19.7485 3.5986 18.5589 2.32405 16.9823 2.32405H4.79396",
    stroke: "#717C91",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6411 19.4413C15.2928 19.4413 15.8212 18.9129 15.8212 18.2612C15.8212 17.6094 15.2928 17.0811 14.6411 17.0811C13.9893 17.0811 13.4609 17.6094 13.4609 18.2612C13.4609 18.9129 13.9893 19.4413 14.6411 19.4413Z",
    stroke: "#717C91",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08637 19.4413C7.73814 19.4413 8.2665 18.9129 8.2665 18.2612C8.2665 17.6094 7.73814 17.0811 7.08637 17.0811C6.43461 17.0811 5.90625 17.6094 5.90625 18.2612C5.90625 18.9129 6.43461 19.4413 7.08637 19.4413Z",
    stroke: "#717C91",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79688 6.22363H19.1261",
    stroke: "#717C91",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseIcon);
export default __webpack_public_path__ + "static/media/purchaseIcon.1f7902ed0eeb57b1959ad036e1548095.svg";
export { ForwardRef as ReactComponent };